// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import { WorkbookVariantFragmentFragmentDoc } from "./Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WorkbookDetailsQueryVariables = Types.Exact<{
  workbookId: Types.Scalars["ID"]["input"];
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type WorkbookDetailsQuery = {
  __typename?: "GraphqlQuery";
  getWorkbookDetails: {
    __typename?: "Workbook";
    id: string;
    name: string;
    description?: string | null;
    createdAt: number;
    lastActivityAt: number;
    databaseId: string;
    issueId?: string | null;
    parameterSetsSelected: boolean;
    parameterRefAliases: Array<string>;
    parameterSetTypes: Array<string | null>;
    explainAnalyzeHelperSource?: string | null;
    server: {
      __typename?: "Server";
      id: string;
      blockSize: number;
      collectorInfo?: {
        __typename?: "CollectorInfo";
        id: string;
        supportsQueryTuning: boolean;
      } | null;
    };
    user?: { __typename?: "User"; id: string; fullname?: string | null } | null;
    parameterSets: Array<{
      __typename?: "WorkbookParameterSet";
      id: string;
      name: string;
      paramValues: any;
    }>;
    aliasParamMapList: Array<{
      __typename?: "AliasParamMap";
      id: string;
      name: string;
      source?: string | null;
      parameters: any;
    }>;
    baselineQuery: {
      __typename?: "WorkbookVariant";
      id: string;
      createdAt: number;
      updatedAt: number;
      description?: string | null;
      queryFingerprint: string;
      queryText: string;
      name: string;
      queryTextWithAlias: string;
      paramRefAliasMap: any;
      draft: boolean;
      plannerSettings: any;
      appliedInsights?: any | null;
      query?: { __typename?: "Query"; id: string; fingerprint: string } | null;
      workbookResults: Array<{
        __typename?: "WorkbookResult";
        id: string;
        format: string;
        resultSource: string;
        createdAt: number;
        updatedAt: number;
        status?: string | null;
        errorMessage?: string | null;
        totalCost?: number | null;
        totalSharedBlksHit?: number | null;
        totalSharedBlksRead?: number | null;
        totalSharedBlksWritten?: number | null;
        totalSharedBlksDirtied?: number | null;
        totalBlkReadTime?: number | null;
        totalBlkWriteTime?: number | null;
        planNodeTypes?: Array<string | null> | null;
        runtimeMs?: number | null;
        planFingerprint?: string | null;
        parameterSetId?: string | null;
        nodeInsights?: any | null;
        user?: {
          __typename?: "User";
          id: string;
          fullname?: string | null;
        } | null;
      }>;
      user?: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
      } | null;
      queryTextWithParameters: Array<{
        __typename?: "QueryTextWithParameters";
        id: string;
        parameterSetId: string;
        queryWithParameters: string;
      }>;
    };
    variants: Array<{
      __typename?: "WorkbookVariant";
      id: string;
      createdAt: number;
      updatedAt: number;
      description?: string | null;
      queryFingerprint: string;
      queryText: string;
      name: string;
      queryTextWithAlias: string;
      paramRefAliasMap: any;
      draft: boolean;
      plannerSettings: any;
      appliedInsights?: any | null;
      query?: { __typename?: "Query"; id: string; fingerprint: string } | null;
      workbookResults: Array<{
        __typename?: "WorkbookResult";
        id: string;
        format: string;
        resultSource: string;
        createdAt: number;
        updatedAt: number;
        status?: string | null;
        errorMessage?: string | null;
        totalCost?: number | null;
        totalSharedBlksHit?: number | null;
        totalSharedBlksRead?: number | null;
        totalSharedBlksWritten?: number | null;
        totalSharedBlksDirtied?: number | null;
        totalBlkReadTime?: number | null;
        totalBlkWriteTime?: number | null;
        planNodeTypes?: Array<string | null> | null;
        runtimeMs?: number | null;
        planFingerprint?: string | null;
        parameterSetId?: string | null;
        nodeInsights?: any | null;
        user?: {
          __typename?: "User";
          id: string;
          fullname?: string | null;
        } | null;
      }>;
      user?: {
        __typename?: "User";
        id: string;
        fullname?: string | null;
      } | null;
      queryTextWithParameters: Array<{
        __typename?: "QueryTextWithParameters";
        id: string;
        parameterSetId: string;
        queryWithParameters: string;
      }>;
    }>;
  };
  getDatabaseDetails: {
    __typename?: "Database";
    id: string;
    permittedToCreateWorkbooks: boolean;
  };
  sharedPreloadLibraries?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
};

export const WorkbookDetailsDocument = gql`
  query WorkbookDetails($workbookId: ID!, $databaseId: ID!) {
    getWorkbookDetails(workbookId: $workbookId) {
      id
      name
      description
      createdAt
      lastActivityAt
      databaseId
      issueId
      server {
        id
        blockSize
        collectorInfo {
          id
          supportsQueryTuning
        }
      }
      user {
        id
        fullname
      }
      parameterSetsSelected
      parameterSets {
        id
        name
        paramValues
      }
      parameterRefAliases
      parameterSetTypes
      aliasParamMapList {
        id
        name
        source
        parameters
      }
      baselineQuery {
        ...WorkbookVariantFragment
        query {
          id
          fingerprint
        }
      }
      variants {
        ...WorkbookVariantFragment
        query {
          id
          fingerprint
        }
      }
      explainAnalyzeHelperSource
    }
    getDatabaseDetails(databaseId: $databaseId) {
      id
      permittedToCreateWorkbooks
    }
    sharedPreloadLibraries: getPostgresSettingDetails(
      databaseId: $databaseId
      postgresSettingName: "shared_preload_libraries"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
  }
  ${WorkbookVariantFragmentFragmentDoc}
`;

/**
 * __useWorkbookDetailsQuery__
 *
 * To run a query within a React component, call `useWorkbookDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkbookDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkbookDetailsQuery({
 *   variables: {
 *      workbookId: // value for 'workbookId'
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useWorkbookDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorkbookDetailsQuery,
    WorkbookDetailsQueryVariables
  > &
    (
      | { variables: WorkbookDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorkbookDetailsQuery, WorkbookDetailsQueryVariables>(
    WorkbookDetailsDocument,
    options,
  );
}
export function useWorkbookDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorkbookDetailsQuery,
    WorkbookDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkbookDetailsQuery,
    WorkbookDetailsQueryVariables
  >(WorkbookDetailsDocument, options);
}
// @ts-ignore
export function useWorkbookDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    WorkbookDetailsQuery,
    WorkbookDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  WorkbookDetailsQuery,
  WorkbookDetailsQueryVariables
>;
export function useWorkbookDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookDetailsQuery,
        WorkbookDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  WorkbookDetailsQuery | undefined,
  WorkbookDetailsQueryVariables
>;
export function useWorkbookDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        WorkbookDetailsQuery,
        WorkbookDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    WorkbookDetailsQuery,
    WorkbookDetailsQueryVariables
  >(WorkbookDetailsDocument, options);
}
export type WorkbookDetailsQueryHookResult = ReturnType<
  typeof useWorkbookDetailsQuery
>;
export type WorkbookDetailsLazyQueryHookResult = ReturnType<
  typeof useWorkbookDetailsLazyQuery
>;
export type WorkbookDetailsSuspenseQueryHookResult = ReturnType<
  typeof useWorkbookDetailsSuspenseQuery
>;
export type WorkbookDetailsQueryResult = Apollo.QueryResult<
  WorkbookDetailsQuery,
  WorkbookDetailsQueryVariables
>;
